import { ContractApi } from './contractApi';

const contractApi = new ContractApi();

export { contractApi };
